module.exports = __webpack_public_path__ + "img/edge_hebergements_hebergement_insolite.b40ffd4d.svg";